import { useState, useEffect, useRef } from "react";

import {
    Button,
    useDisclosure,
    Stack,
    Input,
    InputGroup,
    InputRightElement,
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
} from "@chakra-ui/react";
import { CloseIcon } from "@chakra-ui/icons";

import { updateSolution, deleteSolution } from "../../../../services/SolutionAPI";
import { getSubjectInfoBySolutionId } from "../../../../services/SolutionDetailAPI";

const SolutionCard = (props) => {
    const [isAbleToDeleteSolution, setIsAbleToDeleteSolution] = useState(false);

    const handleOnClick = () => {
        if (window.location.href.includes("solution")) {
            window.location.href = `/admin/solution-detail?id=${props.productID}`;
        } else {
            window.location.href = `/admin/product-detail?id=${props.productID}`;
        }
    };

    const [name, setName] = useState(props.name);
    const [file, setFile] = useState(props.image);
    const [initialTitleName, setInitialTitleName] = useState("선택된 파일이 없습니다");

    const [imgBase64, setImgBase64] = useState(null); // 파일 base64
    const inputRef = useRef(null);

    const editModal = useDisclosure();
    const deletionModal = useDisclosure();

    useEffect(() => {
        setName(props.name);
        setFile("");
        setInitialTitleName(getInitialTitleImageName());
    }, []);

    const openFileExplorer = () => {
        inputRef.current.click();
    };

    const fileChange = (event) => {
        setFile(event.target.files[0]);

        setImgBase64([]);

        for (var i = 0; i < event.target.files.length; i++) {
            if (event.target.files[i]) {
                let reader = new FileReader();
                reader.readAsDataURL(event.target.files[i]); // 1. 파일을 읽어 버퍼에 저장.
                // 파일 상태 업데이트
                reader.onloadend = () => {
                    // 2. 읽기가 완료되면 아래코드가 실행.
                    const base64 = reader.result;
                    if (base64) {
                        // 문자 형태로 저장
                        var base64Sub = base64.toString();
                        // 배열 state 업데이트
                        setImgBase64((imgBase64) => [...imgBase64, base64Sub]);
                    }
                };
            }
        }
    };

    const getInitialTitleImageName = () => {
        let lastSlashIndex = props.image.lastIndexOf("/");
        return props.image.substr(lastSlashIndex + 1);
    };

    const openEditModal = () => {
        setName(props.name);
        setFile(props.image);
        setInitialTitleName(getInitialTitleImageName());

        editModal.onOpen();
    };

    const openDeletionModal = () => {
        deletionModal.onOpen();
    };

    const updateProductInfo = () => {
        updateSolution(props.productID, name, file).then(() => {
            props.setIsSolutionUpdated(true);
            setFile("");
            alert("솔루션 정보가 수정되었습니다!");
        });

        editModal.onClose();
    };

    const removeFile = () => {
        setFile("");
        setImgBase64(null);
    };

    const deleteSolutionCard = () => {
        getSubjectInfoBySolutionId(props.productID).then((result) => {
            if (result.subjectList.length == 0) {
                deleteSolution(props.productID);
                alert("솔루션이 삭제되었습니다");
                props.setIsSolutionUpdated(true);
                deletionModal.onClose();
            } else {
                deletionModal.onClose();
                alert("해당 솔루션에 생성된 구성요소가 한 개 이상 존재하여 삭제할 수 없습니다");
            }
        });
    };

    useEffect(() => {
        getSubjectInfoBySolutionId(props.productID)
            .then((result) => {
                if (result.subjectList.length == 0) {
                    setIsAbleToDeleteSolution(true);
                } else {
                    setIsAbleToDeleteSolution(false);
                }
            })
            .catch((err) => {
                alert("서버에 이상이 있습니다. 관리자에게 문의주세요");
            });
    }, []);

    return (
        <>
            <div
                className="w-[400px] h-[270px] flex flex-col justify-center items-center text-[20px] hover:bg-stone-300 "
                onClick={() => handleOnClick()}
            >
                <img className="w-[390px] h-[200px] mb-[10px] border-solid border-[1px]" style={{objectFit:"contain"}} src={props.image} />
                {props.name}
            </div>

            <div className="pt-[5px] mb-[50px] mr-[10px] flex justify-end gap-[10px]">
                <Button colorScheme="green" fontSize="3xl" px="10px" py="20px" onClick={() => openEditModal()}>
                    편집
                </Button>
                <Button colorScheme="red" fontSize="3xl" px="10px" py="20px" onClick={() => openDeletionModal()}>
                    삭제
                </Button>
            </div>
            {/* 편집 */}
            <Modal onClose={editModal.onClose} isOpen={editModal.isOpen} isCentered>
                <ModalOverlay />

                <ModalContent maxW="500px">
                    <ModalHeader p="20px">
                        <div className="text-4xl pb-[10px]">편집</div>
                        <div className="text-2xl">텍스트 박스를 클릭해 내용을 수정하고 저장 버튼을 클릭해주세요</div>
                    </ModalHeader>

                    <ModalBody px="20px">
                        <Stack direction="column">
                            <Stack direction="column" pb="20px">
                                <div className="text-xl">솔루션명</div>

                                <Stack direction="row" spacing={2}>
                                    <Input
                                        variant="outline"
                                        defaultValue={name}
                                        fontSize="3xl"
                                        py="20px"
                                        w="80%"
                                        value={name || ""}
                                        onChange={(event) => setName(event.target.value)}
                                    />
                                </Stack>
                            </Stack>

                            <Stack direction="column">
                                <div className="text-xl">사진 파일</div>
                                <Stack direction="row" spacing={2}>
                                    <InputGroup w="80%">
                                        <Input
                                            ref={inputRef}
                                            value={file && file.name !== undefined ? file.name : initialTitleName}
                                            fontSize="3xl"
                                            color={file && file.name !== undefined ? "black" : "#a8a8a8"}
                                            py="20px"
                                            isReadOnly
                                            focusBorderColor="none"
                                            _hover={{}}
                                        />
                                        <input
                                            style={{ display: "none" }}
                                            ref={inputRef}
                                            type="file"
                                            accept="image/*"
                                            onChange={fileChange}
                                        />
                                        {file !== null && file !== "" && file.name !== undefined && (
                                            <InputRightElement
                                                children={<CloseIcon color="gray.500" />}
                                                p="20px"
                                                onClick={() => removeFile()}
                                                cursor="pointer"
                                            />
                                        )}
                                    </InputGroup>
                                    <Button
                                        colorScheme="red"
                                        fontSize="2xl"
                                        py="20px"
                                        px="10px"
                                        w="20%"
                                        onClick={openFileExplorer}
                                    >
                                        파일 선택
                                    </Button>
                                </Stack>
                            </Stack>
                        </Stack>
                    </ModalBody>

                    <ModalFooter p="20px">
                        <Button py="20px" mr="10px" fontSize="3xl" onClick={editModal.onClose}>
                            취소
                        </Button>
                        <Button py="20px" fontSize="3xl" onClick={() => updateProductInfo()}>
                            저장
                        </Button>
                    </ModalFooter>
                </ModalContent>
            </Modal>

            {/* 삭제 */}
            <Modal onClose={deletionModal.onClose} isOpen={deletionModal.isOpen} isCentered>
                <ModalOverlay />

                <ModalContent maxW="460px">
                    <ModalHeader p="20px">
                        <div className="text-4xl">삭제</div>
                    </ModalHeader>

                    <ModalBody px="20px" py="0px" fontWeight="bold">
                        {isAbleToDeleteSolution ? (
                            <>
                                <div div className="text-2xl pb-[10px]">
                                    솔루션 정보를 삭제하시겠습니까?
                                </div>
                                <div className="text-2xl">삭제한 솔루션 정보는 복구할 수 없습니다</div>
                            </>
                        ) : (
                            <>
                                <div className="text-2xl pb-[10px]">
                                    해당 솔루션에 생성된 구성요소가 한 개 이상 존재합니다
                                </div>
                                <div className="text-2xl">
                                    솔루션 정보를 삭제하려면 먼저 구성요소를 모두 삭제해주세요
                                </div>
                            </>
                        )}
                    </ModalBody>

                    <ModalFooter p="20px">
                        {isAbleToDeleteSolution ? (
                            <>
                                <Button py="20px" mr="10px" fontSize="3xl" onClick={deletionModal.onClose}>
                                    취소
                                </Button>
                                <Button py="20px" fontSize="3xl" onClick={() => deleteSolutionCard()}>
                                    삭제
                                </Button>
                            </>
                        ) : (
                            <>
                                <Button py="20px" mr="10px" fontSize="3xl" onClick={deletionModal.onClose}>
                                    닫기
                                </Button>
                            </>
                        )}
                    </ModalFooter>
                </ModalContent>
            </Modal>
        </>
    );
};

export default SolutionCard;
